export default {
  methods: {
    buildQuery() {
      var query = {}
      query.projectId = this.$store.state.shared.projectId;
      query.siteId = this.$store.state.shared.siteId;
      query.userId = this.$store.state.shared.selectedUserId;
      query.showClosed = this.$store.state.shared.showClosed;
      query.filterBy = this.$store.state.allocationStaging.filterBy;
      query.filterCol = this.$store.state.allocationStaging.filterCol;
      query.dateRangeStart = this.$store.state.shared.dateRangeStart;
      query.dateRangeEnd = this.$store.state.shared.dateRangeEnd;
      return query;
    }
  }
}